import { Grid, Box } from "@mui/material";
import styles from "./AddFarmBillingEntity.module.scss";
import InputTextField from "../../components/TextField";
import { useAddFarm } from "../../hooks/useAddFarmBillingEntity";

export const BillingEntity = () => {
  const {
    newBillingData,
    billingNameError,
    handlebillingNameChange,
    handleSaveBillingDetails,
  } = useAddFarm();

  return (
    <div className={styles.formContainer}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <InputTextField
            label="Billing Entity"
            placeholder="Enter Billing Entity"
            name="billingEntity"
            value={newBillingData.billingEntityName}
            onChange={handlebillingNameChange}
            className={styles.inputText}
            error={!!billingNameError}
            helperText={billingNameError}
          />
        </Grid>
        <Grid item>
          <Box display="flex" alignItems="flex-end" height="73%">
            <button className={styles.saveButton} onClick={handleSaveBillingDetails}>
              Add
            </button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
